import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestAgendaService } from 'src/app/service/rest/agenda/rest-agenda.service';
import { MaintenanceReminder, MaintenanceReminderUser } from './maintenance.model';

@Injectable()
export class MaintenanceReminderService {

  private _maintenanceReminder: MaintenanceReminderUser;

  constructor(private restAgenda : RestAgendaService) { }

  public get maintenanceReminder(): MaintenanceReminderUser {
    return this._maintenanceReminder;
  }
  public set maintenanceReminder(value: MaintenanceReminderUser) {
    this._maintenanceReminder = value;
  }

  createReminder() : Observable<MaintenanceReminderUser> {
    return this.restAgenda.createMaintenanceReminderUser(this.maintenanceReminder);
  }

  updateReminder() : Observable<MaintenanceReminderUser> {
    return this.restAgenda.updateMaintenanceReminderUser(this.maintenanceReminder);
  }

  deleteReminder() : Observable<MaintenanceReminderUser> {
    return this.restAgenda.deleteMaintenanceReminderUser(this.maintenanceReminder.id);
  }



}
